export const COSTE_POR_PLATO_IMG = '/aprender/coste-por-plato'

export const ESCANDALLO_ROWS = [
    { ingredient: 'Pan brioche', qty: '1 unidad', cost: '0,42 €' },
    { ingredient: 'Carne de vacuno', qty: '180 g', cost: '1,98 €' },
    { ingredient: 'Queso', qty: '2 lonchas', cost: '0,28 €' },
    { ingredient: 'Bacon', qty: '40 g', cost: '0,34 €' },
    { ingredient: 'Lechuga', qty: '20 g', cost: '0,05 €' },
    { ingredient: 'Tomate', qty: '40 g', cost: '0,09 €' },
    { ingredient: 'Cebolla', qty: '20 g', cost: '0,04 €' },
    { ingredient: 'Salsa casera', qty: '30 g', cost: '0,16 €' },
    { ingredient: 'Patatas', qty: '250 g', cost: '0,40 €' },
    { ingredient: 'Aceite para freír', qty: '60 ml', cost: '0,16 €' },
    { ingredient: 'Sal', qty: '2 g', cost: '0,01 €' },
    { ingredient: 'Pimienta y especias', qty: '1 g', cost: '0,02 €' },
] as const
